import React from "react";
import { HeadLine } from "../modules/HeadLine";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
`;

const Box = styled.div`
  width: 425px;
  height: 150px;
  background: #ffffff;
  box-shadow: 0px 0px 50px rgba(31, 32, 33, 0.08);

  @media (max-width: 500px) {
    width: 300px;
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 5rem;

  @media (max-width: 500px) {
    padding: 1.5rem;
  }
`;

const Left = styled(Box)`
  border-radius: 50px 0px 0px 0px;
`;

const Right = styled(Box)`
  border-radius: 0px 0px 50px 0px;
`;

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50px;
  flex-shrink: 0;
`;

const EmailIcon = styled(Icon)`
  background: #11b2ea;
`;

const PhoneIcon = styled(Icon)`
  background: #81c240;
`;

const Heading = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #777984;
`;

const Email = styled.a`
  color: #11b2ea;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
`;

const Phone = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  color: #1f2021;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 2rem;

  @media (max-width: 500px) {
    margin-left: 1rem;
  }
`;

const ContactUs = () => {
  return (
    <div style={{ flex: "80%", padding: "2rem" }}>
      <div style={{ marginBottom: "10px" }}>
        <HeadLine
          headingText={"Contact Us"}
          tagLine={"Choose a convenient way to get in touch:"}
        />
      </div>

      <Container className="flex-col gap-4 xl:flex-row w-fit mx-auto">
        <Left>
          <Content>
            <EmailIcon>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.59955 9.6V14.5C3.59955 15.2 4.39955 15.5 4.89955 15L7.19955 12.3L11.8996 15.8C12.2996 16.1 12.8996 15.9 12.9996 15.4L15.9996 0.9C16.0996 0.3 15.5996 -0.1 14.9996 0.0999996L0.499552 5.9C-0.00044772 6.1 -0.100448 6.8 0.299552 7.2L1.89955 8.4L6.49955 6.2C6.89955 6 7.19955 6.5 6.89955 6.7L3.59955 9.6Z"
                  fill="white"
                />
              </svg>
            </EmailIcon>
            <Text>
              <Heading>Shoot us an email</Heading>
              <Email href="mailto:customersuccess@cardcash.com">
                customersuccess@cardcash.com
              </Email>
            </Text>
          </Content>
        </Left>
        <Right>
          <Content>
            <PhoneIcon>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.0865 10.4L11.9495 9.008C11.6392 8.87073 11.2923 8.83964 10.9625 8.91955C10.6327 8.99946 10.3385 9.18591 10.1255 9.45L9.17848 10.635C7.64382 9.65869 6.34219 8.3574 5.36548 6.823L6.54948 5.877C6.81449 5.6642 7.00172 5.36976 7.08203 5.03951C7.16233 4.70926 7.1312 4.36172 6.99348 4.051L5.60048 0.913999C5.4525 0.580806 5.19103 0.310967 4.86267 0.152555C4.53431 -0.00585769 4.16037 -0.0425555 3.80748 0.048999L1.15548 0.737999C0.789606 0.833577 0.471491 1.06002 0.26139 1.37443C0.0512898 1.68885 -0.036205 2.0694 0.0154791 2.444C0.506594 5.86121 2.09143 9.0274 4.53268 11.4685C6.97393 13.9095 10.1402 15.4941 13.5575 15.985C13.6277 15.9949 13.6985 15.9999 13.7695 16C14.1109 15.9998 14.4426 15.8864 14.7128 15.6776C14.9829 15.4688 15.1762 15.1764 15.2625 14.846L15.9505 12.193C16.0434 11.8402 16.0074 11.4659 15.849 11.1372C15.6907 10.8086 15.4203 10.5472 15.0865 10.4Z"
                  fill="white"
                />
              </svg>
            </PhoneIcon>
            <Text>
              <Heading>Call us</Heading>
              <Phone>1 800 227 4214</Phone>
            </Text>
          </Content>
        </Right>
      </Container>
    </div>
  );
};

ContactUs.propTypes = {};

export default ContactUs;
